export const API_ROUTES = {
  PAYWALL: '/api/paywall',
  INFO: '/info',
  DATA_PREPARER_INFO: '/api/infoparameter/getdatapreparerdownloadstatus?os=',
  DATA_PREPARER_VERSION: '/api/infoparameter/getdatapreparerlastversion',
  DATA_PREPARER_DOWNLOAD: '/api/datamanagement/DataPreparer?os=',
  AIRES_FILES_IS_EMPTY: '/api/datamanagement/airesfilesisempty',
  GET_SUBMISSIONS: '/api/submissions',
  UPLOAD_FILES: '/api/datamanagement/memberdata',
  AIRES_DATA: '/api/datamanagement/airesfiles',
  DELETE_SUBMISSION: '/api/datamanagement/memberdata',
  AIRES_FILES_STATUSES: '/api/datamanagement/airesfilesstatuses',
  DATA_REPORT: '/api/datamanagement/dataqualityvalidation',
  MAPPING_STATUS: '/api/datamanagement/airesmappingstatus',
  DOWNLOAD_LOAN_TEMPLATE: '/api/datamanagement/downloadprefilledloanmaptemplate',
  DOWNLOAD_SHARE_TEMPLATE: '/api/datamanagement/downloadprefilledsharemaptemplate',
  DOWNLOAD_PFC_TEMPLATE: '/api/datamanagement/downloadprefilledpfcmaptemplate',
  GET_LOANS_MAPPING_DATA: '/api/datamanagement/loanmappingdata',
  GET_LOAN_TYPES: '/api/datamanagement/loantypes',
  GET_SHARES_TYPES: '/api/datamanagement/sharetypes',
  SAVE_LOAN_TYPE: '/api/datamanagement/submitnewloanmaprow',
  GET_SHARES_MAPPING_DATA: '/api/datamanagement/sharemappingdata',
  SAVE_SHARE_TYPE: '/api/datamanagement/submitnewsharemaprow',
  ASSIGN_LOAN_TYPES: '/api/datamanagement/submiteditedloanmaprows',
  ASSIGN_SHARE_TYPES: '/api/datamanagement/submiteditedsharemaprows',
  SUBMIT_LOAN_TEMPLATE: '/api/datamanagement/submitloanmaptemplate',
  SUBMIT_SHARE_TEMPLATE: '/api/datamanagement/submitsharemaptemplate',
  SUBMIT_PFC_TEMPLATE: '/api/datamanagement/submitpfcmaptemplate',
  GET_PFC_MAPPING_DATA: '/api/datamanagement/pfcodedata',
  PFC_MEANING_DATA: '/api/datamanagement/pfcmeaning',
  PFC_EDIT_ROW: '/api/datamanagement/submiteditedpfcrow',
  PFC_EDIT_ROWS: '/api/datamanagement/submiteditedpfcrows',
  SAVE_PFC_DEFINITION: '/api/datamanagement/submitnewpfcdefinition',
  SUBMISSION_HISTORY: '/api/datamanagement/submissionhistory',
  UI_STATUS_GET_STATUS: '/api/uistatus/getstatus',
  UI_STATUS_UPDATE_STATUS: '/api/uistatus/updatestatus',
} as const;
